const breakpoints = {
  mobileS: 345,
  mobileM: 375,
  mobileL: 425,
  mobileXL: 480,
};

export const MobileBreakpoints = (key) => {
  return (style) => `@media (max-width: ${breakpoints[key]}px) { ${style} }`;
};
